module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.d22b4ee10045e0a50508.js");
};